import { render, staticRenderFns } from "./device_kpi.vue?vue&type=template&id=31ed2ae2&scoped=true&"
import script from "./device_kpi.vue?vue&type=script&lang=js&"
export * from "./device_kpi.vue?vue&type=script&lang=js&"
import style0 from "./device_kpi.vue?vue&type=style&index=0&id=31ed2ae2&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ed2ae2",
  null
  
)

export default component.exports